var React = require('react');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : { default: e };
}

var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);

const PLACEHOLDER = /\{(.*?)\}/g;
/**
 * This function accepts a string with placeholder tokens and replaces each with
 * the corresponding value from `values` object.
 * For example:
 * resolvePlaceholders('Hello {name}', { name: 'Alice' }) // "Hello Alice"
 */
function resolvePlaceholders(input, values) {
  return input.replace(PLACEHOLDER, (match, word) => {
    return values[word] != null ? String(values[word]) : match;
  });
}

const TAG = /<(.*?)>(.*?)<\/(.*?)>/g;
function resolveTags(
  input,
  resolvers,
  /** This allows us to wrap a ReactNode in a Fragment with a key */
  wrap,
) {
  const result = [];
  let index = 0;
  input.replace(TAG, (match, startTag, content, endTag, i) => {
    if (i > index) {
      result.push(wrap(input.slice(index, i)));
      index = i;
    }
    index += match.length;
    if (startTag === endTag) {
      const resolver = resolvers[startTag];
      const node = typeof resolver === 'function' ? resolver(content) : match;
      result.push(wrap(node));
    } else {
      result.push(wrap(match));
    }
    return match;
  });
  if (index < input.length) {
    result.push(wrap(input.slice(index)));
  }
  return result;
}

/**
 * React version of the t() function; takes a string and some parameters and
 * returns a fully-resolved ReactNode.
 */
const t = (text, ...[values]) => {
  return values ? resolveAll(text, values) : text;
};
function resolveAll(input, values) {
  const resolvedText = resolvePlaceholders(input, values);
  return resolveTagsReact(resolvedText, values);
}
/**
 * This function accepts ranges of text delineated by a start and end tag
 * (syntax similar to html). The text between start and end tags will be passed
 * into a render function named after the tag name.
 * For example:
 * resolveTags('Hello <b>world</b>', { b: (content) => <Bold>{content}</Bold> })
 */
function resolveTagsReact(input, resolvers) {
  let i = 0;
  // Allow specifying a function to wrap raw text (useful in RN)
  const wrapText = maybeFn(resolvers._);
  const wrap = wrapText
    ? (node) => (typeof node === 'string' ? wrapText(node) : node)
    : (node) => node;
  const result = resolveTags(input, resolvers, (node) =>
    React__default['default'].createElement(
      React.Fragment,
      { key: i++ },
      wrap(node),
    ),
  );
  return React__default['default'].createElement(
    React__default['default'].Fragment,
    null,
    result,
  );
}
function maybeFn(input) {
  return typeof input === 'function' ? input : undefined;
}

exports.t = t;
